import {Component, Object3D} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {WLUtils} from '../utils/WLUtils.js';
import {RewardPicker} from './reward-picker.js';
import {RNG} from '../utils/rng.js';

export class RewardScene extends Component {
    static TypeName = 'reward-scene';

    private static _instance: RewardScene;
    static get instance(): RewardScene {
        return RewardScene._instance;
    }

    @property.object({required: true})
    slot1!: Object3D;

    @property.object({required: true})
    slot2!: Object3D;

    @property.object({required: true})
    slot3!: Object3D;

    @property.object({required: true})
    blobsBackground!: Object3D;

    init(): void {
        // make sure the "scene" starts inactive
        WLUtils.setActive(this.object, false);
        if (RewardScene._instance) {
            console.error('There can only be one instance of RewardScene Component');
        }
        RewardScene._instance = this;
    }

    show() {
        WLUtils.setActive(this.blobsBackground, false);
        WLUtils.setActive(this.object, true);
        this._initialize();
    }

    hide() {
        WLUtils.setActive(this.blobsBackground, true);
        WLUtils.setActive(this.object, false);
    }

    private _initialize() {
        const blobs = RNG.getItems(
            [
                'Piece Green',
                'Piece Yellow',
                'Piece Pink',
                'Piece Orange',
                'Piece Red',
                'Piece Blue',
                'Piece Purple',
            ],
            3
        );
        this.slot1.getComponent(RewardPicker).initialize(blobs[0]);
        this.slot2.getComponent(RewardPicker).initialize(blobs[1]);
        this.slot3.getComponent(RewardPicker).initialize(blobs[2]);
    }
}
